import React from "react";
import { observer } from "mobx-react";
import { Button } from "@mui/material";
import { FolderSharedIcon } from "../../../icons";
import { useRootStore } from "../../../store/contexts";

type GridExpressProps = {
  onClick: () => void;
  disabled?: boolean;
};

export const SaveProfileButton: React.FC<GridExpressProps> = observer(
  ({ onClick, disabled }) => {
    const rootStore = useRootStore();
    const { prefStore, langStore } = rootStore;

    return (
      <Button
        variant={"action"}
        size={prefStore.toolbarSize}
        startIcon={<FolderSharedIcon />}
        disabled={disabled === undefined ? false : disabled}
        onClick={onClick}
      >
        {langStore.saveProfile}
      </Button>
    );
  }
);
